define(['skins', 'santa-components'], function (skins, santaComponents) {
    'use strict';
    return santaComponents.mixins.textScaleMixin(skins.skinsMap);
});
